import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "block space-y-4 w-screen px-4 md:w-full" }
const _hoisted_2 = { class: "flex w-full" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "flex-shrink-0 w-4" }
const _hoisted_5 = { class: "flex-grow text-right" }
const _hoisted_6 = { class: "w-4" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-sm divide-y divide-y-brand-main" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex-1" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "text-sm grid gap-2 grid-cols-6" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src", "alt"]

import {ref} from "vue";
import {useI18n} from "vue-i18n";

const pageStr = "components.itemV2.itemV2Engraving"


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV2Engraving',
  props: ["engraving"],
  emits: ['update:engraving', 'patch', 'switch:image'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit

const {t} = useI18n();
const showFonts = ref(false);
const showSymbols = ref(false);
const textInput = ref<HTMLElement[] | null>(null);
const engravingFonts = {
  "Amsterdam": "Amsterdam",
  "Arial": "Arial",
  "AvantGarde": "Avant Garde",
  "Benguiat": "Benguiat",
  "Berlin": "Berlin",
  "BoereTudor": "Boere Tudor",
  "EdwardianScriptITC": "Edwardian Script ITC (ID: 10)",
  "EnglischeSchT": "Englische SchT (ID: 3)",
  "English111VivaceBT": "English 111 Vivace BT (ID: 11)",
  "FreestyleScript": "Freestyle Script (ID: 16)",
  "PalaceScript": "Palace Script (ID: 4)",
  "Genf": "Genf",
  "Italic": "Italic",
  "Koeln": "Koeln",
  "LegerD": "LegerD (ID: 15)",
  "MonotypeCorsiva": "Monotype Corsiva (ID: 14)",
  "NuptialBT": "Nuptial BT",
  "Oslo": "Oslo",
  "PalatinoLinotype": "Palatino Linotype (ID: 62)",
  "Paris": "Paris",
  "ScriptMTBold": "Script MT Bold",
  "SloganD": "SloganD",
  "TimesNewRoman": "Times New Roman (ID: 2)",
  "Vivaldi": "Vivaldi (ID: 13)"
}

const engravingSymbols: { [key: string]: string } = {
  // a_Herz.dxf
  "heart": "Ⓐ",
  // b_Doppelherz.dxf
  "doubleHeart": "Ⓒ",
  // c_Doppelherz-m-Pfeil.dxf
  "doubleHeartArrow": "Ⓑ",
  // d_Herz-m-Pfreil.dxf
  "heartArrow": "Ⓓ",
  // e_Doppelringe.dxf
  "doubleRings": "Ⓘ",
  // f_Taube.dxf
  "pigeon": "Ⓙ",
  // g_Infinity-Zeichen.dxf
  "infinity": "Ⓕ",
  // h_Herzschloss.dxf
  "heartCastle": "Ⓚ",
  // i_Anker.dxf
  "anchor": "Ⓝ",
  // j_Glaube-Liebe-Hoffnung.dxf
  //"faith": "Ⓔ",
  // k_Amors-Bogen.dxf
  "amorArrow": "Ⓖ",
  // l_Amor.dxf
  "amor": "Ⓗ",
  // m_Krone.dxf
  "crown": "Ⓛ",
  // n_Kutsche.dxf
  //"carriage": "Ⓞ"
}

const addSymbole = (symboleIdx: string) => {
  const pos = textInput.value?.selectionStart || 0
  const symbole = engravingSymbols[symboleIdx]

  refEngraving.value.text = refEngraving.value.text.slice(0, pos) + " " + symbole + " " + refEngraving.value.text.slice(pos);

  refEngraving.value.text = refEngraving.value.text.replace(/ +(?= )/g, '')

  updateFont()

  emit('patch', {
    action: 'engraving.inside.text',
    value: refEngraving.value.text,
    certificated_diamond: true
  });

}

const refEngraving = ref(props.engraving);

const selectFont = (fontId: string) => {
  refEngraving.value.font = fontId;

  updateFont()

  emit('patch', {
    action: 'engraving.inside.font',
    value: refEngraving.value.font,
    certificated_diamond: true
  });
}

const updateFont = () => {
  refEngraving.value.text = refEngraving.value.text.trim()

  emit('update:engraving', refEngraving.value);
  emit('switch:image', 'Engraving')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refEngraving.value.text) = $event)),
        ref_key: "textInput",
        ref: textInput,
        onKeyup: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$emit('update:engraving', __props.engraving);_ctx.$emit('switch:image', 'Engraving')}),
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('patch', {action: 'engraving.inside.text', value: refEngraving.value.text.trim(), certificated_diamond: true}))),
        class: "text-base block w-full bg-white p-2 border border-brand-main",
        style: _normalizeStyle({fontFamily: refEngraving.value.font})
      }, null, 36), [
        [_vModelText, refEngraving.value.text]
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "w-1/3 flex cursor-pointer",
        onClick: _cache[3] || (_cache[3] = ($event: any) => {showSymbols.value = !showSymbols.value; showFonts.value = false})
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", {
            class: _normalizeClass(["block text-black pr-1 text-xs", {'font-bold': showSymbols.value}])
          }, _toDisplayString(_unref(t)(pageStr + '.symbols')), 3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: _normalizeClass(["w-4 h-4 transition-transform duration-300", { 'rotate-180': showSymbols.value }]),
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 9l-7 7-7-7"
            }, null, -1)
          ]))], 2))
        ])
      ]),
      _createElementVNode("div", {
        class: "w-2/3 flex cursor-pointer",
        onClick: _cache[4] || (_cache[4] = ($event: any) => {showFonts.value = !showFonts.value; showSymbols.value = false})
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", {
            class: _normalizeClass(["block text-black pr-1 text-xs overflow-hidden whitespace-nowrap", {'font-bold': showFonts.value}])
          }, _toDisplayString(_unref(t)(pageStr + '.font')) + " " + _toDisplayString(engravingFonts[__props.engraving.font.toString()]), 3)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: _normalizeClass(["w-4 h-4 transition-transform duration-300", { 'rotate-180': showFonts.value }]),
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 9l-7 7-7-7"
            }, null, -1)
          ]))], 2))
        ])
      ])
    ]),
    (showFonts.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(engravingFonts, (font, fontIdx) => {
              return _createElementVNode("li", {
                key: fontIdx,
                class: "flex cursor-pointer py-2 hover:bg-gray-100",
                onClick: ($event: any) => (selectFont(fontIdx))
              }, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(font), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["flex-1 overflow-hidden whitespace-nowrap", fontIdx]),
                  style: _normalizeStyle({fontFamily: fontIdx})
                }, _toDisplayString(refEngraving.value.text), 7)
              ], 8, _hoisted_9)
            }), 64))
          ])
        ]))
      : _createCommentVNode("", true),
    (showSymbols.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("ul", _hoisted_12, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(engravingSymbols, (symbole, symboleIdx) => {
              return _createElementVNode("li", {
                key: symboleIdx,
                class: "cursor-pointer p-4 hover:bg-gray-100 text-center flex items-center justify-center",
                onClick: ($event: any) => (addSymbole(symboleIdx as string))
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/img/symbols/' + symboleIdx.toString() + '.png'),
                  alt: symboleIdx.toString()
                }, null, 8, _hoisted_14)
              ], 8, _hoisted_13)
            }), 64))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})